import { render, staticRenderFns } from "./JsonTreeNode.vue?vue&type=template&id=485bd7a6&scoped=true"
import script from "./JsonTreeNode.vue?vue&type=script&lang=js"
export * from "./JsonTreeNode.vue?vue&type=script&lang=js"
import style0 from "./JsonTreeNode.vue?vue&type=style&index=0&id=485bd7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485bd7a6",
  null
  
)

export default component.exports